import {useSelector} from 'react-redux'

export const useHasRequiredRecords = keys => {
	return useSelector(state => keys.every(key => state.records[key]))
}
